import { useState, useContext, useEffect } from "react";
import { AuthContext } from "../../shared/context/auth-context";
import { ClinicaContext } from "../../shared/context/clinica-context";
import Sidebar from "../../shared/components/sidebar/Sidebar";
import Navbar from "../../shared/components/navbar/Navbar";
import { useHttpClient } from "../../shared/hooks/http-hook";
import PdfFaturaWrapper from "../../shared/components/PdfGenerator/PdfFatura/PdfFaturaWrapper";
import PdfRceWrapper from "../../shared/components/PdfGenerator/PdfRce/PdfRceWrapper";
//MUI
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import CallMadeIcon from "@mui/icons-material/CallMade";
import CallReceivedIcon from "@mui/icons-material/CallReceived";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

import "./Financeiro.scss";

import Saidas from "./saidas/Saidas";
import FluxoCaixa from "./fluxoCaixa/FluxoCaixa";
import FechoCaixa from "./fechoCaixa/FechoCaixa";
import Receitas from "./receitas/Receitas";
import PdfReciboWrapper from "../../shared/components/PdfGenerator/PdfRecibo/PdfReciboWrapper";
import PdfFluxoCaixaWrapper from "../../shared/components/PdfGenerator/PdfFluxoCaixa/PdfFluxoCaixaWrapper";
import DepositosDashboard from "./depositosDashboard/DepositosDashboard";
import ContingenciaDocumentos from "./contingenciaDocumentos/ContingenciaDocumentos";

/* ─── CLÍNICAS QUE SÓ VEEM O FLUXO DE CAIXA ─────────────────────────────────
 *
 * No Financeiro, a aba do Fluxo e a do Fecho são mutuamente exclusivas: a do
 * Fluxo só aparece quando o Fecho está escondido, e o `Ctrl+Shift+F` TROCA uma
 * pela outra — nunca mostra as duas.
 *
 * Nestas clínicas o Fecho de Caixa não é usado. A aba não aparece e o atalho
 * não chega a ser registado: sem isso, quem o carregasse por engano perdia o
 * Fluxo e ficava sem perceber porquê.
 *
 * A primeira já estava assim, mas escrita em dois sítios separados — o valor
 * inicial e o registo do atalho. Juntá-las numa lista é o que permite
 * acrescentar uma clínica num sítio só.
 */
const CLINICAS_SO_FLUXO_CAIXA = [
  "6817794da65ef747fc74730d", // Oral Care Lda
  "6ace7a602522761ad12c04b5", // Clínica Dentária Prodente (base de testes)
  "6ae22f1303cc296c280be37f", // Clínica Dentária Prodente (produção)
];

function Financeiro() {
  const [showMainTabs, setShowMainTabs] = useState();
  const [showPdfFatura, setShowPdfFatura] = useState(false);
  const [faturaData, setFaturaData] = useState({});
  const [reciboData, setReciboData] = useState({ show: false });
  const [fluxoCaixaData, setFluxoCaixaData] = useState({ show: false });

  const [dadosClinica, setDadosClinica] = useState();
  const [dadosFatura, setDadosFatura] = useState({ show: false });
  const [dadosRce, setDadosRce] = useState({ show: false });

  const { sendRequest } = useHttpClient();

  const auth = useContext(AuthContext);
  const clinica = useContext(ClinicaContext);

  const soFluxoCaixa = CLINICAS_SO_FLUXO_CAIXA.includes(clinica.clinica._id);

  const [showFechoCaixa, setShowFechoCaixa] = useState(!soFluxoCaixa);

  const [showReceitas, setShowReceitas] = useState(
    clinica.clinica._id === "63230ebecb8db95d70cb3456" ? false : true,
  );

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.ctrlKey && e.shiftKey && e.key.toLowerCase() === "f") {
        setShowFechoCaixa((prev) => {
          const novoValor = !prev;
          setShowMainTabs(novoValor ? "fechoCaixa" : "fluxoCaixa");
          return novoValor;
        });
      }

      if (
        e.ctrlKey &&
        e.shiftKey &&
        e.key.toLowerCase() === "d" &&
        clinica.clinica._id === "63230ebecb8db95d70cb3456"
      ) {
        e.preventDefault(); // impede abrir bookmarks
        e.stopPropagation();
        setShowReceitas((prev) => {
          const novoValor = !prev;
          setShowMainTabs(novoValor ? "receitas" : "saidas");
          return novoValor;
        });
      }
    };

    /* Nas clínicas sem Fecho de Caixa o atalho nem se regista — o
       `Ctrl+Shift+F` não faz nada. Ver `CLINICAS_SO_FLUXO_CAIXA`. */
    if (!soFluxoCaixa) {
      window.addEventListener("keydown", handleKeyDown);
      return () => window.removeEventListener("keydown", handleKeyDown);
    }
  }, [clinica.clinica._id, soFluxoCaixa]);

  useEffect(() => {
    const fetchDadosClinica = async () => {
      try {
        const responseData = await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/clinicas/${clinica.clinica._id}`,
          "GET",
          null,
          {
            Authorization: "Bearer " + auth.token,
          },
        );
        setDadosClinica(responseData.clinica);
      } catch (err) {
        console.error(err);
      }
    };

    fetchDadosClinica();
  }, [auth.token, clinica, sendRequest]);

  useEffect(() => {
    const abaAMostrar =
      auth.perm.includes("r-parc") &&
      clinica.clinica._id !== "63230ebecb8db95d70cb3456"
        ? "receitas"
        : auth.perm.includes("r-des")
          ? "saidas"
          : auth.perm.includes("r-flxcx")
            ? "fluxoCaixa"
            : "";

    setShowMainTabs(abaAMostrar);
  }, []);

  const showFatura = (dadosFatura) => {
    setDadosFatura(dadosFatura);
  };

  const showRce = (dadosRce) => {
    setDadosRce(dadosRce);
  };

  const dadosRecibo = (dados) => {
    setReciboData({ ...dados, show: true });
  };

  const dadosFluxoCaixa = (dados) => {
    setFluxoCaixaData({
      dados: { ...dados, clinica: clinica.clinica.nome },
      show: true,
    });
  };

  const showPreviousPage = () => {
    if (dadosRce.show) {
      setDadosRce({ show: false });
    }

    if (fluxoCaixaData.show) {
      setFluxoCaixaData({ show: false });
    }

    if (reciboData.show) {
      setReciboData({ show: false });
    }

    if (showPdfFatura) {
      setShowPdfFatura(false);
    }
    if (dadosFatura.show) {
      setDadosFatura({ show: false });
    }
    if (faturaData) {
      setFaturaData({});
    }
  };

  return (
    <>
      {showPdfFatura && (
        <PdfFaturaWrapper
          showPreviousPage={showPreviousPage}
          faturaData={faturaData}
        />
      )}

      {dadosFatura.show && (
        <PdfFaturaWrapper
          showPreviousPage={showPreviousPage}
          faturaData={dadosFatura}
        />
      )}

      {dadosRce.show && (
        <PdfRceWrapper
          showPreviousPage={showPreviousPage}
          reciboData={dadosRce}
        />
      )}

      {reciboData.show && (
        <PdfReciboWrapper
          showPreviousPage={showPreviousPage}
          reciboData={reciboData}
        />
      )}

      {fluxoCaixaData.show && (
        <PdfFluxoCaixaWrapper
          showPreviousPage={showPreviousPage}
          dados={fluxoCaixaData}
        />
      )}

      <div className="new">
        <Sidebar />
        <div className="newContainer">
          <Navbar title="Financeiro" icon={AttachMoneyIcon} />

          <div className="single__abas-principais single__abas-principais--financeiro">
            {(auth.perm.includes("r-parc") || auth.perm.includes("r-ent")) &&
              showReceitas && (
                <span
                  className={`single__abas-principais__aba ${
                    showMainTabs === "receitas" &&
                    "single__abas-principais__aba--active"
                  }`}
                  onClick={() => setShowMainTabs("receitas")}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                  }}
                >
                  Receitas
                  <CallReceivedIcon style={{ color: "rgb(116, 169, 37)" }} />
                </span>
              )}

            {auth.perm.includes("r-des") && (
              <span
                className={`single__abas-principais__aba ${
                  showMainTabs === "saidas" &&
                  "single__abas-principais__aba--active"
                }`}
                onClick={() => setShowMainTabs("saidas")}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "5px",
                }}
              >
                Saídas <CallMadeIcon style={{ color: "crimson" }} />
              </span>
            )}

            {auth.perm.includes("r-flxcx") && showFechoCaixa === false && (
              <span
                className={`single__abas-principais__aba ${
                  showMainTabs === "fluxoCaixa" &&
                  "single__abas-principais__aba--active"
                }`}
                onClick={() => setShowMainTabs("fluxoCaixa")}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "5px",
                }}
              >
                Fluxo de Caixa
              </span>
            )}

            {/* {auth.perm.includes("r-fxcx") && ( */}
            {showFechoCaixa && (
              <span
                className={`single__abas-principais__aba ${
                  showMainTabs === "fechoCaixa" &&
                  "single__abas-principais__aba--active"
                }`}
                onClick={() => setShowMainTabs("fechoCaixa")}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "5px",
                }}
              >
                Fecho de Caixa
              </span>
            )}
            {/* )} */}

            <span
              className={`single__abas-principais__aba ${
                showMainTabs === "depositos" &&
                "single__abas-principais__aba--active"
              }`}
              onClick={() => setShowMainTabs("depositos")}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              Depositos
            </span>

            <span
              className={`single__abas-principais__aba ${
                showMainTabs === "contingencia" &&
                "single__abas-principais__aba--active"
              }`}
              onClick={() => setShowMainTabs("contingencia")}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              <WarningAmberIcon style={{ color: "#ff6b00" }} />
              Contingência
            </span>
          </div>

          {showMainTabs === "receitas" && dadosClinica && (
            <Receitas
              clinicaId={clinica.clinica._id}
              auth={auth}
              showFatura={showFatura}
              showRce={showRce}
              dadosClinica={dadosClinica}
              dadosRecibo={dadosRecibo}
            />
          )}
          {showMainTabs === "saidas" && dadosClinica && (
            <Saidas
              clinicaId={clinica.clinica._id}
              auth={auth}
              clinicaData={clinica.clinica}
            />
          )}

          {(showMainTabs === "fluxoCaixa" || showMainTabs === "fechoCaixa") &&
            dadosClinica &&
            (showFechoCaixa ? (
              <FechoCaixa
                clinicaId={clinica.clinica._id}
                auth={auth}
                dadosFechoCaixa={dadosFluxoCaixa}
                showFatura={showFatura}
                dadosClinica={dadosClinica}
                showRce={showRce}
              />
            ) : (
              <FluxoCaixa
                clinicaId={clinica.clinica._id}
                auth={auth}
                dadosFluxoCaixa={dadosFluxoCaixa}
                showFatura={showFatura}
                dadosClinica={dadosClinica}
                showRce={showRce}
              />
            ))}

          {showMainTabs === "depositos" && (
            <DepositosDashboard clinicaId={clinica.clinica._id} auth={auth} />
          )}

          {showMainTabs === "contingencia" && (
            <ContingenciaDocumentos
              clinicaId={clinica.clinica._id}
              auth={auth}
            />
          )}
        </div>
      </div>
    </>
  );
}

export default Financeiro;
